import { render } from "./Paginacion.vue?vue&type=template&id=8557065e"
import script from "./Paginacion.vue?vue&type=script&lang=js"
export * from "./Paginacion.vue?vue&type=script&lang=js"

import "./Paginacion.vue?vue&type=style&index=0&id=8557065e&lang=scss"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__